import { getDeviceInfo } from "@magalu/rave/router";

export interface INationalUrl {
  desktop: string;
  mobile: string;
}

function isValidNationalUrls(nationalUrls: INationalUrl): boolean {
  return (
    nationalUrls &&
    typeof nationalUrls === "object" &&
    typeof nationalUrls.mobile === "string" &&
    typeof nationalUrls.desktop === "string"
  );
}

export default function getNationalUrlByDevice(nationalUrls: INationalUrl) {
  const { type } = getDeviceInfo();
  if (!isValidNationalUrls(nationalUrls)) return "";

  return type ? nationalUrls.mobile : nationalUrls.desktop;
}
